import React from 'react';

function BannerSection({ title, subtitle, description, backgroundId = 'default-banner', backgroundImage }) {
  const bannerStyle = {
    backgroundImage: backgroundImage 
      ? `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${backgroundImage})` 
      : 'linear-gradient(to right, #198754, #145c3b)', 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    // Ajuste de altura e preenchimento para não sumir atrás do header
    minHeight: '450px', 
    paddingTop: '80px', // Isso empurra o conteúdo para baixo da barra do header
  };

  return (
    <>
      <style>
        {`
          .banner-container {
            width: 100%;
            display: flex;
            justify-content: flex-start;
          }

          .title-banner {
            max-width: 1000px;
            padding: 2rem 5% 2rem 10%; /* Padding lateral consistente */
            z-index: 2;
          }

          .title-banner h1 {
            font-size: clamp(1.8rem, 5vw, 3.2rem);
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: -1px;
            margin-bottom: 0.8rem;
            line-height: 1.1;
          }

          .title-banner h5 {
            color: #ffffff;
            font-weight: 600;
            margin-bottom: 1.2rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            font-size: clamp(1rem, 2vw, 1.3rem);
          }

          .title-banner h6 {
            color: #f0f0f0;
            font-weight: 400;
            font-size: 1.1rem;
            line-height: 1.7;
            max-width: 750px;
            text-align: left; /* Alinhado à esquerda fica mais moderno em banners */
          }

          @media (max-width: 768px) {
            #backImage {
              min-height: 400px;
              padding-top: 100px; /* Mais espaço no mobile para o menu sanduíche */
              justify-content: center;
            }
            .title-banner {
              padding: 1.5rem;
              text-align: center;
            }
            .title-banner h6 {
              text-align: center;
              font-size: 1rem;
            }
          }
        `}
      </style>

      <div id="backImage" className="banner" style={bannerStyle}>
        <div className="banner-container">
          <div className="title-banner" id={backgroundId}>
            <h1 style={{ color:'#198754' }}>{title}</h1>
            {subtitle && <h5>{subtitle}</h5>}
            <h6>{description}</h6>
          </div>
        </div>
      </div>
    </>
  );
}

export default BannerSection;